module.exports = __webpack_public_path__ + "img/training-extreme.207828bf.svg";